var _line, _line2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogSectionBgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    y1: 1080,
    transform: "translate(1666)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x1: 1920,
    transform: "translate(0 120)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_28-02-2023",
    "data-name": "28-02-2023",
    transform: "translate(1314 360)",
    fill: "#a2a2a2",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 15,
    fontFamily: "SegoeUI-Light, Segoe UI",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "28-02-2023"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogSectionBgLines);
export default __webpack_public_path__ + "static/media/BlogSectionBgLines.1b8071ae15dfabf7b318f0e013485101.svg";
export { ForwardRef as ReactComponent };